import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { api } from "../../lib/api";

const when = (s) => new Date(s).toLocaleString("en-GB", { weekday: "short", hour: "2-digit", minute: "2-digit", timeZone: "Africa/Accra" });

export const ReminderWatcher = () => {
  const seen = useRef(new Set());
  useEffect(() => {
    if ("Notification" in window && Notification.permission === "default") Notification.requestPermission();
    const check = async () => {
      try {
        const { data } = await api.get("/desk/reminders");
        data.filter((r) => !seen.current.has(r.id)).forEach((r) => {
          seen.current.add(r.id);
          const msg = `${r.title}${r.with_whom ? ` with ${r.with_whom}` : ""} · ${when(r.start)}${r.location ? ` · ${r.location}` : ""}`;
          toast(`Reminder: ${r.title}`, { description: msg, duration: 20000, action: { label: "Done", onClick: () => api.post(`/desk/reminders/${r.id}/dismiss`) } });
          if ("Notification" in window && Notification.permission === "granted") new Notification("DGC reminder", { body: msg, icon: "/brand/dgc-crest.png" });
        });
      } catch { /* offline */ }
    };
    check();
    const t = setInterval(check, 60000);
    return () => clearInterval(t);
  }, []);
  return null;
};
